/**
 * Trigger a browser download of a same-origin asset (e.g. a hosted PDF). Used by
 * the Playbooks hub so a visitor downloads the guide directly from the site after
 * we capture their lead. We deliberately do NOT email files to visitors (LoanLoop's
 * Resend account is transactional broker/tenant mail only).
 *
 * The `download` attribute only forces a save (rather than in-browser open) for
 * same-origin URLs, which our /playbooks/*.pdf assets are.
 */
export function downloadAsset(path: string, filename?: string): void {
  if (typeof document === 'undefined') return
  const a = document.createElement('a')
  a.href = path
  if (filename) a.download = filename
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
}
